/* ============================================================
   PINKSTAR — interaction engine
   Classic script (no modules) so it also runs from file://
   Live store: talks to Shopify /cart/*.js
   Demo:      falls back to an in-memory cart
   ============================================================ */
(function () {
  "use strict";

  var LIVE = typeof window.Shopify === "object" && window.Shopify !== null;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var ROOT = document.documentElement;

  function money(cents) {
    var cfg = window.PINKSTAR || {};
    var n = (cents / 100).toFixed(2).replace(/\.00$/, "");
    return (cfg.currencySymbol || "$") + n;
  }
  function parseJSONAttr(el, name) {
    var raw = el ? el.getAttribute(name) : null;
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  /* ---------------- input modality ----------------
     Rings belong to keyboard navigation only. Track the last input type
     and tag focusable controls, so a tap never leaves an outline behind
     (Safari keeps :focus-visible after touch on buttons). */
  var kb = false;
  function markKb(on) {
    kb = on;
    document.documentElement.classList.toggle("ps-kb", on);
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Tab" || e.key.indexOf("Arrow") === 0) markKb(true);
  }, true);
  ["pointerdown", "mousedown", "touchstart"].forEach(function (t) {
    document.addEventListener(t, function () { markKb(false); }, true);
  });
  document.addEventListener("focusin", function (e) {
    var el = e.target;
    if (!el || !el.classList) return;
    el.classList.toggle("is-kb", kb);
  }, true);
  document.addEventListener("focusout", function (e) {
    if (e.target && e.target.classList) e.target.classList.remove("is-kb");
  }, true);

  /* ---------------- theme ---------------- */
  var Theme = {
    init: function () {
      var saved = null;
      try { saved = localStorage.getItem("ps-theme"); } catch (e) {}
      if (saved) ROOT.setAttribute("data-ps-theme", saved);
      $$("[data-ps-theme-toggle]").forEach(function (b) {
        b.addEventListener("click", Theme.flip);
      });
    },
    flip: function () {
      var cur = ROOT.getAttribute("data-ps-theme") === "dark" ? "dark" : "light";
      var next = cur === "dark" ? "light" : "dark";
      ROOT.setAttribute("data-ps-theme", next);
      try { localStorage.setItem("ps-theme", next); } catch (e) {}
    }
  };

  /* ---------------- toast ---------------- */
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "ps-toast ps-glass";
      toastEl.setAttribute("role", "status");
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add("is-on");
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove("is-on"); }, 2000);
  }

  /* ---------------- horizontal blur engine ----------------
     Shared by the feed's image rails and the product view.
     Writes --q (0 centred/sharp -> 1 off-centre) per child.      */
  function HRail(scroller, onIndex) {
    if (!scroller) return null;
    var shots = $$(".ps-shot", scroller);
    if (!shots.length) return null;
    var ticking = false, cur = -1;

    function paint() {
      var w = scroller.clientWidth || 1;
      var mid = scroller.scrollLeft + w / 2;
      var best = 0, bestD = Infinity;
      for (var i = 0; i < shots.length; i++) {
        var s = shots[i];
        var c = s.offsetLeft + s.offsetWidth / 2;
        var ad = Math.abs(mid - c);
        var q = RM ? 0 : clamp(ad / (w * 0.72), 0, 1);
        // --q inherits down to the <img>, which owns the blur
        s.style.setProperty("--q", q.toFixed(3));
        if (ad < bestD) { bestD = ad; best = i; }
      }
      if (best !== cur) { cur = best; if (onIndex) onIndex(best); }
    }
    scroller.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { paint(); ticking = false; });
    }, { passive: true });
    paint();
    return { paint: paint, index: function () { return cur; } };
  }

  /* ---------------- vertical swipe feed ---------------- */
  var Feed = {
    init: function () {
      var feed = $("[data-ps-feed]");
      if (!feed) return;
      Feed.el = feed;
      Feed.slides = $$(".ps-slide", feed);
      if (!Feed.slides.length) return;
      Feed.ticking = false;
      Feed.cur = -1;

      Feed.slides.forEach(function (slide) {
        // per-slide horizontal rail for its own images
        var dots = $$(".ps-slide__dots i", slide);
        HRail($(".ps-rail-x", slide), function (i) {
          dots.forEach(function (d, di) { d.classList.toggle("is-on", di === i); });
        });
        Feed.wireTap(slide);
      });

      feed.addEventListener("scroll", Feed.onScroll, { passive: true });
      window.addEventListener("resize", Feed.paint);
      Feed.paint();
    },

    /* a tap (not a swipe) opens the product view */
    wireTap: function (slide) {
      var sx = 0, sy = 0, moved = false;
      slide.addEventListener("pointerdown", function (e) {
        sx = e.clientX; sy = e.clientY; moved = false;
      });
      slide.addEventListener("pointermove", function (e) {
        if (Math.abs(e.clientX - sx) > 9 || Math.abs(e.clientY - sy) > 9) moved = true;
      });
      slide.addEventListener("pointerup", function (e) {
        if (moved) return;
        if (e.target.closest("a,button")) return;
        PV.open(slide);
      });
    },

    onScroll: function () {
      if (Feed.ticking) return;
      Feed.ticking = true;
      requestAnimationFrame(function () { Feed.paint(); Feed.ticking = false; });
    },

    paint: function () {
      var h = Feed.el.clientHeight || window.innerHeight;
      var mid = Feed.el.scrollTop + h / 2;
      var best = 0, bestD = Infinity;
      for (var i = 0; i < Feed.slides.length; i++) {
        var s = Feed.slides[i];
        var c = s.offsetTop + s.offsetHeight / 2;
        var d = mid - c;                       // signed
        var ad = Math.abs(d);
        // p: 0 centred & sharp -> 1 fully blurred.
        var p = RM ? 0 : clamp(ad / (h * 0.58), 0, 1);
        var media = $(".ps-slide__media", s);
        if (media) {
          // --p inherits through the rail to each <img>, which owns the blur
          media.style.setProperty("--p", p.toFixed(3));
          media.style.setProperty("--dir", d > 0 ? "-1" : "1");
        }
        var meta = $(".ps-slide__meta", s);
        if (meta) meta.style.setProperty("--p", p.toFixed(3));
        if (ad < bestD) { bestD = ad; best = i; }
      }
      if (best !== Feed.cur) { Feed.cur = best; Feed.onSlide(best); }
    },

    onSlide: function (i) {
      var railCur = $("[data-ps-rail-cur]");
      if (railCur) {
        var n = String(i + 1);
        railCur.textContent = n.length < 2 ? "0" + n : n;
        railCur.classList.remove("is-step");
        void railCur.offsetWidth;
        railCur.classList.add("is-step");
      }
    }
  };
  /* ---------------- product view ----------------
     Opens over the feed. Builds its gallery from the slide's data
     attributes, so no network round-trip and no page load.          */
  var PV = {
    el: null, rail: null, variants: null, vIndex: 0, shots: [],
    options: [], chosen: [],

    mount: function () {
      if (PV.el) return PV.el;
      var el = document.createElement("div");
      el.className = "ps-pv";
      el.setAttribute("role", "dialog");
      el.setAttribute("aria-modal", "true");
      el.setAttribute("aria-label", "Product");
      el.innerHTML =
        '<div class="ps-pv__media"><div class="ps-rail-x" data-pv-rail></div></div>' +
        '<div class="ps-pv__dots" data-pv-dots aria-hidden="true"></div>' +
        '<div class="ps-swatches ps-glass" data-pv-thumbs hidden></div>' +
        '<div class="ps-sheet ps-glass" data-pv-sheet>' +
          '<div class="ps-sheet__grip" aria-hidden="true"></div>' +
          '<div class="ps-sheet__row">' +
            '<h2 class="ps-sheet__name" data-pv-name></h2>' +
            '<span class="ps-sheet__sub ps-label" data-pv-sub></span>' +
          "</div>" +
          '<div class="ps-sheet__more"><div>' +
            '<ul class="ps-bullets" data-pv-bullets hidden></ul>' +
            '<div data-pv-options></div>' +
            '<button type="button" class="ps-sizechart" data-pv-sizechart hidden>' +
              '<span data-pv-sizechart-label>Size chart</span>' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 4h6v6M20 4l-8.5 8.5M18 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4"/></svg>' +
            "</button>" +
          "</div></div>" +
          '<button type="button" class="ps-cta" data-pv-add>' +
            '<span data-pv-add-label>Add to cart</span>' +
            '<span data-pv-add-price></span>' +
          "</button>" +
        "</div>";
      document.body.appendChild(el);
      PV.el = el;
      $("[data-pv-add]", el).addEventListener("click", PV.onAdd);
      $("[data-pv-sizechart]", el).addEventListener("click", function () {
        Overlay.open("sizechart");
      });
      return el;
    },

    /* ---- photo rail + thumbnail strip (photos, NOT variants) ---- */
    paintShots: function (images) {
      var el = PV.el;
      var rail = $("[data-pv-rail]", el);
      var dots = $("[data-pv-dots]", el);
      var thumbs = $("[data-pv-thumbs]", el);
      rail.innerHTML = "";
      dots.innerHTML = "";
      thumbs.innerHTML = "";
      PV.shots = images.length ? images : [""];

      PV.shots.forEach(function (src, i) {
        var d = document.createElement("div");
        d.className = "ps-shot";
        if (src) {
          var im = document.createElement("img");
          im.src = src;
          im.alt = "";
          im.loading = i === 0 ? "eager" : "lazy";
          d.appendChild(im);
        }
        rail.appendChild(d);

        if (PV.shots.length > 1) {
          var dot = document.createElement("i");
          if (i === 0) dot.className = "is-on";
          dots.appendChild(dot);

          // one thumbnail per PHOTO; jumps the rail to that photo
          var b = document.createElement("button");
          b.className = "ps-swatch ps-tap";
          b.type = "button";
          b.setAttribute("aria-pressed", String(i === 0));
          b.setAttribute("aria-label", "Photo " + (i + 1));
          if (src) {
            var ti = document.createElement("img");
            ti.src = src; ti.alt = ""; ti.loading = "lazy";
            b.appendChild(ti);
          }
          b.addEventListener("click", function () {
            rail.scrollTo({ left: i * rail.clientWidth, behavior: RM ? "auto" : "smooth" });
          });
          thumbs.appendChild(b);
        }
      });

      thumbs.hidden = PV.shots.length < 2;
      rail.scrollLeft = 0;

      var ds = $$("i", dots);
      var tb = $$(".ps-swatch", thumbs);
      PV.rail = HRail(rail, function (i) {
        ds.forEach(function (d, di) { d.classList.toggle("is-on", di === i); });
        tb.forEach(function (t, ti) { t.setAttribute("aria-pressed", String(ti === i)); });
      });
    },

    /* ---- variant option circles, inside the sheet ---- */
    paintOptions: function () {
      var host = $("[data-pv-options]", PV.el);
      if (!host) return;
      host.innerHTML = "";   // always clear: PV is reused across products
      if (!PV.options || !PV.options.length) return;

      PV.options.forEach(function (opt, oi) {
        var group = document.createElement("div");
        group.className = "ps-optgroup";

        var lab = document.createElement("div");
        lab.className = "ps-optgroup__label";
        var sel = PV.chosen[oi];
        lab.innerHTML = '<span class="ps-label">' + opt.name + "</span>" +
                        (sel ? "<em>[ " + sel + " ]</em>" : "");
        group.appendChild(lab);

        var row = document.createElement("div");
        row.className = "ps-opts";
        opt.values.forEach(function (val) {
          var b = document.createElement("button");
          b.className = "ps-opt";
          b.type = "button";
          b.textContent = val;
          b.setAttribute("aria-pressed", String(sel === val));
          if (!PV.valueReachable(oi, val)) b.disabled = true;
          b.addEventListener("click", function () {
            PV.chosen[oi] = val;
            PV.resolve();
          });
          row.appendChild(b);
        });
        group.appendChild(row);
        host.appendChild(group);
      });
    },

    /* is any in-stock variant still available with this value? */
    valueReachable: function (oi, val) {
      return PV.variants.some(function (v) {
        if (v.available === false) return false;
        var vv = v.values || [];
        if (vv[oi] !== val) return false;
        return PV.chosen.every(function (c, ci) {
          return ci === oi || !c || vv[ci] === c;
        });
      });
    },

    /* map the chosen option values onto a concrete variant */
    resolve: function () {
      var full = PV.options.every(function (_, i) { return !!PV.chosen[i]; });
      if (full) {
        for (var i = 0; i < PV.variants.length; i++) {
          var vv = PV.variants[i].values || [];
          if (PV.chosen.every(function (c, ci) { return vv[ci] === c; })) {
            PV.setVariant(i);
            PV.paintOptions();
            return;
          }
        }
      }
      PV.vIndex = -1;
      PV.paintOptions();
      PV.paintCta();
    },

    /* CTA reflects whether a variant still needs choosing */
    paintCta: function () {
      var el = PV.el;
      var cta = $("[data-pv-add]", el);
      var lbl = $("[data-pv-add-label]", el);
      var price = $("[data-pv-add-price]", el);
      cta.classList.remove("is-added", "is-busy");

      var needsChoice = PV.options && PV.options.length && PV.vIndex < 0;
      if (needsChoice) {
        cta.classList.add("ps-cta--select");
        cta.disabled = false;
        cta.dataset.variantId = "";
        lbl.textContent = "Select options";
        price.textContent = PV.priceRange();
        return;
      }

      cta.classList.remove("ps-cta--select");
      var v = PV.variants[PV.vIndex] || PV.variants[0];
      var sold = !v || v.available === false;
      cta.disabled = sold;
      cta.dataset.variantId = v ? v.id : "";
      cta.dataset.price = v ? String(v.price) : "0";
      cta.dataset.image = v ? ((v.images && v.images[0]) || v.image || "") : "";
      lbl.textContent = sold ? "Sold out" : "Add to cart";
      price.textContent = sold ? "" : money(v.price);
    },

    priceRange: function () {
      var ps = PV.variants.map(function (v) { return v.price; });
      var lo = Math.min.apply(null, ps);
      return money(lo);
    },

    setVariant: function (i) {
      PV.vIndex = i;
      var v = PV.variants[i];
      if (!v) return;
      var el = PV.el;
      $("[data-pv-sub]", el).textContent = v.title || "";
      PV.paintCta();
      PV.paintShots(v.images && v.images.length ? v.images : (v.image ? [v.image] : []));
    },

    open: function (slide) {
      var variants = parseJSONAttr(slide, "data-variants");
      if (!variants || !variants.length) return;
      PV.variants = variants;
      PV.options = parseJSONAttr(slide, "data-options") || [];
      PV.chosen = PV.options.map(function () { return null; });

      var el = PV.mount();
      var sheet = $("[data-pv-sheet]", el);
      $("[data-pv-name]", el).textContent = slide.getAttribute("data-title") || "";

      // bullets from the product description
      var bl = parseJSONAttr(slide, "data-bullets") || [];
      var ul = $("[data-pv-bullets]", el);
      ul.innerHTML = "";
      bl.forEach(function (t) {
        var li = document.createElement("li");
        li.textContent = t;
        ul.appendChild(li);
      });
      ul.hidden = bl.length === 0;

      // size chart: only when enabled in the dashboard AND the overlay exists
      var sc = $("[data-pv-sizechart]", el);
      var cfg = (window.PINKSTAR || {}).sizeChart || {};
      var scOn = cfg.enabled && !!$('[data-ps-overlay="sizechart"]') && PV.options.length > 0;
      sc.hidden = !scOn;
      if (scOn && cfg.title) $("[data-pv-sizechart-label]", el).textContent = cfg.title;

      // single-variant products: select it up front and keep the sheet collapsed
      if (PV.options.length) {
        sheet.classList.remove("is-expanded");
        PV.vIndex = -1;
        PV.paintOptions();
        PV.paintCta();
        PV.paintShots(parseJSONAttr(slide, "data-images") || []);
        $("[data-pv-sub]", el).textContent = variants[0].title || "";
      } else {
        sheet.classList.remove("is-expanded");
        PV.paintOptions();     // clears any groups left by a previous product
        PV.vIndex = 0;
        PV.setVariant(0);
      }

      // morph origin: start from where the tapped image sits
      var img = $(".ps-shot img", slide) || $(".ps-slide__media", slide);
      if (img && !RM) {
        var r = img.getBoundingClientRect();
        var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        el.style.setProperty("--pv-ox", cx + "px");
        el.style.setProperty("--pv-oy", cy + "px");
      }

      el.classList.add("is-mounted");
      ROOT.classList.add("ps-pv-on");
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.classList.add("is-open"); });
      });
      PV.lastFocus = document.activeElement;
      setTimeout(function () {
        // Focus the panel, not the CTA. Focusing the button programmatically
        // is what drew a focus ring around the add-to-cart pill.
        el.setAttribute("tabindex", "-1");
        el.focus({ preventScroll: true });
        if (PV.rail) PV.rail.paint();
      }, 120);
    },

    close: function () {
      var el = PV.el;
      if (!el || !el.classList.contains("is-open")) return;
      el.classList.remove("is-open");
      ROOT.classList.remove("ps-pv-on");
      setTimeout(function () { el.classList.remove("is-mounted"); }, 520);
      if (PV.lastFocus && PV.lastFocus.focus) PV.lastFocus.focus();
      if (Feed.el) Feed.paint();
    },

    isOpen: function () { return !!(PV.el && PV.el.classList.contains("is-open")); },

    onAdd: function (e) {
      var cta = e.currentTarget;

      // "Select options" expands the sheet instead of adding
      if (cta.classList.contains("ps-cta--select")) {
        var sheet = $("[data-pv-sheet]", PV.el);
        sheet.classList.add("is-expanded");
        var first = $(".ps-opt:not([disabled])", sheet);
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 240);
        return;
      }

      if (!RM) {
        var r = cta.getBoundingClientRect();
        var sp = document.createElement("span");
        sp.className = "ps-cta__ripple";
        var size = Math.max(r.width, r.height) * 2;
        sp.style.width = sp.style.height = size + "px";
        sp.style.left = (e.clientX - r.left) + "px";
        sp.style.top = (e.clientY - r.top) + "px";
        cta.appendChild(sp);
        setTimeout(function () { sp.remove(); }, 640);
      }
      Cart.add(cta.dataset.variantId, {
        title: $("[data-pv-name]", PV.el).textContent,
        price: parseInt(cta.dataset.price || "0", 10),
        image: cta.dataset.image
      }, cta, "[data-pv-add-label]");
    }
  };
  /* ---------------- cart ---------------- */
  var Cart = {
    demo: { items: [] },

    init: function () {
      $$("[data-ps-cart-open]").forEach(function (b) {
        b.addEventListener("click", function () { Cart.refresh().then(function () { Overlay.open("cart"); }); });
      });
      Cart.refresh();
    },

    add: function (variantId, meta, cta, labelSel) {
      if (!variantId) { toast("Unavailable"); return; }
      var lbl = cta ? $(labelSel || "[data-ps-add-label]", cta) : null;
      var done = function () {
        if (cta) {
          cta.classList.remove("is-busy");
          cta.classList.add("is-added");
          if (lbl) lbl.textContent = "Added ✓";
          setTimeout(function () {
            cta.classList.remove("is-added");
            if (lbl) lbl.textContent = "Add to cart";
          }, 1800);
        }
        Cart.bump();
        Cart.refresh().then(function () { Overlay.open("cart"); });
      };
      if (cta) cta.classList.add("is-busy");

      if (!LIVE) {
        var hit = null;
        Cart.demo.items.forEach(function (it) { if (it.id === variantId) hit = it; });
        if (hit) hit.quantity += 1;
        else Cart.demo.items.push({
          id: variantId, key: variantId,
          title: meta.title || "Item", price: meta.price || 0,
          quantity: 1, image: meta.image || ""
        });
        setTimeout(done, 260);
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error("add failed");
        done();
      }).catch(function () {
        if (cta) cta.classList.remove("is-busy");
        toast("Could not add");
      });
    },

    change: function (key, qty) {
      if (!LIVE) {
        Cart.demo.items = Cart.demo.items.filter(function (it) {
          if (it.key !== key) return true;
          it.quantity = qty;
          return qty > 0;
        });
        return Cart.refresh();
      }
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { return Cart.refresh(); })
        .catch(function () { toast("Update failed"); });
    },

    state: function () {
      if (!LIVE) {
        var total = 0, count = 0;
        Cart.demo.items.forEach(function (i) { total += i.price * i.quantity; count += i.quantity; });
        return Promise.resolve({
          item_count: count, total_price: total,
          items: Cart.demo.items.map(function (i) {
            return {
              key: i.key, id: i.id, product_title: i.title, quantity: i.quantity,
              line_price: i.price * i.quantity, image: i.image
            };
          })
        });
      }
      return fetch("/cart.js", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .catch(function () { return { item_count: 0, total_price: 0, items: [] }; });
    },

    bump: function () {
      $$("[data-ps-cart-count]").forEach(function (el) {
        el.classList.remove("is-bump");
        void el.offsetWidth;
        el.classList.add("is-bump");
      });
    },

    refresh: function () {
      return Cart.state().then(function (c) {
        $$("[data-ps-cart-count]").forEach(function (el) { el.textContent = c.item_count; });
        Cart.render(c);
        return c;
      });
    },
    render: function (c) {
      var list = $("[data-ps-cart-items]");
      var foot = $("[data-ps-cart-total]");
      if (!list) return;

      if (!c.items.length) {
        list.innerHTML = '<p class="ps-cart__empty">Your cart is empty</p>';
        if (foot) foot.textContent = money(0);
        var sw0 = $("[data-ps-ship-wrap]");
        if (sw0) sw0.hidden = true;
        return;
      }

      list.innerHTML = "";
      c.items.forEach(function (it) {
        var row = document.createElement("div");
        row.className = "ps-cart__item";
        // Shopify CDN URLs take a _160x size suffix; data: URIs must be left alone.
        var img = it.image ? String(it.image) : "";
        if (img && img.slice(0, 5) !== "data:") {
          img = img.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2");
        }
        row.innerHTML =
          '<div class="ps-cart__thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : "") + "</div>" +
          '<div><div class="ps-cart__t"><span>' + (it.product_title || "") + "</span><span>" + money(it.line_price) + "</span></div>" +
          '<div class="ps-cart__qty"><span class="ps-label">Qty</span>' +
          '<span class="ps-stepper"><button type="button" data-ps-dec aria-label="Decrease quantity">&minus;</button>' +
          "<span>" + it.quantity + "</span>" +
          '<button type="button" data-ps-inc aria-label="Increase quantity">+</button></span>' +
          '<button type="button" class="ps-cart__del ps-glass ps-tap" data-ps-del>Delete</button></div></div>';

        $("[data-ps-dec]", row).addEventListener("click", function () { Cart.change(it.key, it.quantity - 1); });
        $("[data-ps-inc]", row).addEventListener("click", function () { Cart.change(it.key, it.quantity + 1); });
        $("[data-ps-del]", row).addEventListener("click", function () {
          row.classList.add("is-going");
          setTimeout(function () { Cart.change(it.key, 0); }, 260);
        });
        list.appendChild(row);
      });

      if (foot) foot.textContent = money(c.total_price);

      // free shipping progress
      var cfg = window.PINKSTAR || {};
      var th = parseInt(cfg.freeShipping || 0, 10);
      var wrap = $("[data-ps-ship-wrap]");
      if (wrap && th > 0) {
        wrap.hidden = false;
        var left = th - c.total_price;
        var msg = $("[data-ps-ship-msg]");
        var bar = $("[data-ps-ship-bar]");
        if (msg) msg.textContent = left > 0
          ? "You're " + money(left) + " away from free shipping"
          : "Free shipping unlocked";
        if (bar) bar.style.width = clamp((c.total_price / th) * 100, 0, 100) + "%";
      } else if (wrap) {
        wrap.hidden = true;
      }
    }
  };
  /* ---------------- splash ----------------
     Plays once per session. The inline head script already decided
     whether to show it, so there is never a flash on refresh.        */
  var Splash = {
    KEY: "ps-entered",
    init: function () {
      var el = $("[data-ps-splash]");
      if (!el) return;
      $$("[data-ps-enter]", el).forEach(function (b) {
        b.addEventListener("click", function (e) {
          e.preventDefault();
          Splash.leave();
        });
      });
    },
    leave: function () {
      var el = $("[data-ps-splash]");
      if (!el) return;
      try { sessionStorage.setItem(Splash.KEY, "1"); } catch (e) {}
      el.classList.add("is-leaving");
      ROOT.classList.remove("ps-splash-on");
      setTimeout(function () {
        el.style.display = "none";
        if (Feed.el) Feed.paint();
      }, RM ? 0 : 680);
    }
  };

  /* ---------------- overlays ---------------- */
  var Overlay = {
    cur: null,
    init: function () {
      $$("[data-ps-open]").forEach(function (b) {
        b.addEventListener("click", function () { Overlay.open(b.getAttribute("data-ps-open")); });
      });
      $$("[data-ps-close]").forEach(function (b) {
        b.addEventListener("click", Overlay.close);
      });
      $$("[data-ps-overlay] .ps-overlay__veil").forEach(function (v) {
        v.addEventListener("click", Overlay.close);
      });
      document.addEventListener("keydown", function (e) {
        if (e.key !== "Escape") return;
        if (Overlay.cur) { Overlay.close(); return; }
        if (PV.isOpen()) PV.close();
      });
    },
    open: function (name) {
      var el = $('[data-ps-overlay="' + name + '"]');
      if (!el) return;
      if (Overlay.cur === el) { Overlay.close(); return; }   // same trigger toggles
      if (Overlay.cur) Overlay.close();
      if (name === "menu") ROOT.classList.add("ps-menu-open");
      Overlay.cur = el;
      el.classList.add("is-open");
      el.setAttribute("aria-hidden", "false");
      $$(".ps-menu__link", el).forEach(function (l, i) {
        l.style.transitionDelay = RM ? "0s" : (0.04 + i * 0.035).toFixed(3) + "s";
      });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.classList.add("is-shown"); });
      });
      var f = el.querySelector("[data-ps-close],a,button");
      if (f) setTimeout(function () { f.focus(); }, 120);
    },
    close: function () {
      var el = Overlay.cur;
      if (!el) return;
      Overlay.cur = null;
      ROOT.classList.remove("ps-menu-open");
      el.classList.remove("is-shown");
      el.setAttribute("aria-hidden", "true");
      setTimeout(function () {
        el.classList.remove("is-open");
        $$(".ps-menu__link", el).forEach(function (l) { l.style.transitionDelay = ""; });
      }, 420);
    }
  };

  /* ---------------- feed <-> grid ---------------- */
  var View = {
    init: function () {
      var feed = $("[data-ps-feed]"), grid = $("[data-ps-grid]");
      if (!feed || !grid) return;
      $$("[data-ps-view-toggle]").forEach(function (b) {
        b.addEventListener("click", function () {
          var toGrid = feed.hidden === false;
          feed.hidden = toGrid;
          grid.hidden = !toGrid;
          $$("[data-ps-feed-only]").forEach(function (e) { e.hidden = toGrid; });
          b.setAttribute("aria-pressed", String(toGrid));
          b.setAttribute("aria-label", toGrid ? "Switch to swipe view" : "Switch to grid view");
          ROOT.classList.toggle("ps-grid-on", toGrid);
          if (toGrid) View.reveal(); else Feed.paint();
        });
      });
    },
    reveal: function () {
      var cards = $$("[data-ps-grid] .ps-card");
      if (RM || !("IntersectionObserver" in window)) {
        cards.forEach(function (c) { c.classList.add("is-in"); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var i = cards.indexOf(en.target);
          en.target.style.transitionDelay = ((i % 4) * 0.055).toFixed(3) + "s";
          en.target.classList.add("is-in");
          io.unobserve(en.target);
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
      cards.forEach(function (c) { io.observe(c); });
    }
  };

  /* grid cards open the product view in place when they carry variant data */
  function initCards() {
    $$(".ps-card[data-variants]").forEach(function (card) {
      card.addEventListener("click", function (e) {
        if (!parseJSONAttr(card, "data-variants")) return;  // let the link work
        e.preventDefault();
        PV.open(card);
      });
    });
  }

  /* ---------------- accordion ---------------- */
  function initAccordions() {
    $$("[data-ps-acc]").forEach(function (acc) {
      var q = $(".ps-acc__q", acc), a = $(".ps-acc__a", acc);
      if (!q || !a) return;
      q.setAttribute("aria-expanded", "false");
      q.addEventListener("click", function () {
        var open = acc.classList.toggle("is-open");
        q.setAttribute("aria-expanded", String(open));
        a.style.height = open ? a.firstElementChild.offsetHeight + "px" : "0px";
      });
    });
  }

  /* ---------------- standalone product page ----------------
     Server-rendered markup, but reuses PV's option/CTA logic by pointing
     PV at the page's own sheet. */
  function initProductPage() {
    var cta = $("[data-ps-page-add]");
    if (!cta) return;

    var rail = $("[data-ps-page-rail]");
    var dots = $$("[data-ps-page-dots] i");
    var thumbs = $$("[data-ps-page-thumbs] .ps-swatch");

    if (rail) {
      var r = HRail(rail, function (i) {
        dots.forEach(function (d, di) { d.classList.toggle("is-on", di === i); });
        thumbs.forEach(function (t, ti) { t.setAttribute("aria-pressed", String(ti === i)); });
      });
      thumbs.forEach(function (t, i) {
        t.addEventListener("click", function () {
          rail.scrollTo({ left: i * rail.clientWidth, behavior: RM ? "auto" : "smooth" });
        });
      });
      if (r) r.paint();
    }

    // drive the CTA through PV's shared logic, minus the overlay
    PV.el = $("[data-ps-page-sheet]").closest(".ps-pv-page") || document;
    PV.variants = parseJSONAttr(cta, "data-variants") || [];
    PV.options = parseJSONAttr(cta, "data-options") || [];
    PV.chosen = PV.options.map(function () { return null; });

    var sheet = $("[data-ps-page-sheet]");
    var optHost = $("[data-ps-page-options]");
    var sub = $("[data-ps-page-sub]");
    var lbl = $("[data-ps-add-label]", cta);
    var price = $("[data-ps-add-price]", cta);

    function paintOpts() {
      if (!optHost) return;
      optHost.innerHTML = "";
      PV.options.forEach(function (opt, oi) {
        var group = document.createElement("div");
        group.className = "ps-optgroup";
        var sel = PV.chosen[oi];
        var lab = document.createElement("div");
        lab.className = "ps-optgroup__label";
        lab.innerHTML = '<span class="ps-label">' + opt.name + "</span>" +
                        (sel ? "<em>[ " + sel + " ]</em>" : "");
        group.appendChild(lab);
        var row = document.createElement("div");
        row.className = "ps-opts";
        opt.values.forEach(function (val) {
          var b = document.createElement("button");
          b.className = "ps-opt";
          b.type = "button";
          b.textContent = val;
          b.setAttribute("aria-pressed", String(sel === val));
          if (!PV.valueReachable(oi, val)) b.disabled = true;
          b.addEventListener("click", function () { PV.chosen[oi] = val; sync(); });
          row.appendChild(b);
        });
        group.appendChild(row);
        optHost.appendChild(group);
      });
    }

    function sync() {
      var idx = -1;
      if (PV.options.every(function (_, i) { return !!PV.chosen[i]; })) {
        PV.variants.forEach(function (v, i) {
          var vv = v.values || [];
          if (idx < 0 && PV.chosen.every(function (c, ci) { return vv[ci] === c; })) idx = i;
        });
      }
      paintOpts();

      if (PV.options.length && idx < 0) {
        cta.classList.add("ps-cta--select");
        cta.dataset.variantId = "";
        lbl.textContent = "Select options";
        return;
      }
      cta.classList.remove("ps-cta--select");
      var v = PV.variants[idx] || PV.variants[0];
      if (!v) return;
      var sold = v.available === false;
      cta.disabled = sold;
      cta.dataset.variantId = v.id;
      cta.dataset.price = String(v.price);
      if (sub) sub.textContent = v.title || "";
      lbl.textContent = sold ? "Sold out" : "Add to cart";
      if (price) price.textContent = sold ? "" : money(v.price);
    }

    if (PV.options.length) sync();

    cta.addEventListener("click", function () {
      if (cta.classList.contains("ps-cta--select")) {
        sheet.classList.add("is-expanded");
        var f = $(".ps-opt:not([disabled])", sheet);
        if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 240);
        return;
      }
      Cart.add(cta.dataset.variantId, {
        title: cta.dataset.productTitle,
        price: parseInt(cta.dataset.price || "0", 10),
        image: cta.dataset.image
      }, cta, "[data-ps-add-label]");
    });
  }

  /* ---------------- checkout ---------------- */
  function initCheckout() {
    $$("[data-ps-checkout]").forEach(function (b) {
      b.addEventListener("click", function (e) {
        if (!LIVE) { e.preventDefault(); toast("Demo — checkout disabled"); return; }
        window.location.href = "/checkout";
      });
    });
  }

  /* ---------------- boot ---------------- */
  function boot() {
    Theme.init();
    Splash.init();
    Overlay.init();
    Feed.init();
    Cart.init();
    View.init();
    initCards();
    initAccordions();
    initCheckout();

    initProductPage();

    $$("[data-ps-pv-close]").forEach(function (b) {
      b.addEventListener("click", PV.close);
    });

    if ($("[data-ps-grid]") && !$("[data-ps-feed]")) View.reveal();
    ROOT.classList.add("ps-ready");
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  window.PinkstarUI = { toast: toast, cart: Cart, overlay: Overlay, theme: Theme, pv: PV };
})();
